import { createSlice } from "@reduxjs/toolkit";

export const int009_post_scheduler = createSlice({
  name: "int009_post_scheduler",
  initialState: {
    value: {
      devolutionInformation: {
        status: "abe",
        cnpj: "",
        numero_contrato: "",
        propsota: "",
        numero_serie: "",
        numero_interno: "",
        codigo_filial: "",
        tipo_frete: "",
        data_chegada: "",
        hora_chegada: "",
        numero_nf: "",
        nf_base64: null,
        resposta_checklist: {
          "Bateria está carregada?": { resposta: "", observacao: "" },
          "O tanque contém 1/4 de combustível?": {
            resposta: "",
            observacao: "",
          },
          "Local apto a carregamento?": { resposta: "", observacao: "" },
          "Necessita motorista habilitado para o carregamento?": {
            resposta: "",
            observacao: "",
          },
          "Precisa que envie os dados de carregamento com antecedência?": {
            resposta: "",
            observacao: "",
          },
          "Qual antecedência?": { resposta: "", observacao: "" },
          "Há alguma restrição de horário?": { resposta: "", observacao: "" },
          "Há alguma restrição de espaço para o transporte?": {
            resposta: "",
            observacao: "",
          },
        },
      },
      filialEquipmentInformation: {
        openHour: false,
        closeHour: false,
      }
    },
  },
  reducers: {
    setPayload(state, { payload }) {
      state.value.devolutionInformation[Object.keys(payload)] =
        payload[Object.keys(payload)];
    },
    setFilialOpenHour (state, {payload}) {
      state.value.filialEquipmentInformation.openHour = payload
    },
    setFilialCloseHour (state, {payload}) {
      state.value.filialEquipmentInformation.closeHour = payload
    },
    setBateriaEstaCarregada(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Bateria está carregada?"
      ] = payload;
    },
    setLocalAptoCarregamento(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Local apto a carregamento?"
      ] = payload;
    },
    setTanqueCombustivel(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "O tanque contém 1/4 de combustível?"
      ] = payload;
    },
    setNecessitaMotorista(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Necessita motorista habilitado para o carregamento?"
      ] = payload;
    },
    setNecessitaAntecedencia(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Precisa que envie os dados de carregamento com antecedência?"
      ] = payload;
    },
    setAntecedencia(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Qual antecedência?"
      ] = payload;
    },
    setRestricaoHorario(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Há alguma restrição de horário?"
      ] = payload;
    },
    setRestricaoHorarioObservacao(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Há alguma restrição de horário?"
      ].observacao = payload;
    },
    setRestricaoTransporte(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Há alguma restrição de espaço para o transporte?"
      ] = payload;
    },
    setRestricaoTransporteObservacao(state, { payload }) {
      state.value.devolutionInformation.resposta_checklist[
        "Há alguma restrição de espaço para o transporte?"
      ].observacao = payload;
    },
  },
});

export const {
  setPayload,
  setFilialOpenHour,
  setFilialCloseHour,
  setBateriaEstaCarregada,
  setLocalAptoCarregamento,
  setTanqueCombustivel,
  setNecessitaMotorista,
  setNecessitaAntecedencia,
  setAntecedencia,
  setRestricaoHorario,
  setRestricaoHorarioObservacao,
  setRestricaoTransporte,
  setRestricaoTransporteObservacao,
} = int009_post_scheduler.actions;
export default int009_post_scheduler.reducer;
